import ApplicationCompanyBase from '../components/base/application-company-base';
import React from 'react';

const GeneralApplicationCompany = () => {
  return <ApplicationCompanyBase sportType="general" />;
};

export default GeneralApplicationCompany;
